import React from 'react';
import classNames from './zippy.module.scss';
import Conditional from '../../common/conditional';

interface InspectionStandardProps {
	onEdit?: () => void;
	onRemove: () => void;
	body: string;
	title: string;
}

const InspectionStandard: React.FC<InspectionStandardProps> = ({
	body,
	title,
	onEdit,
	onRemove,
}) => {
	return (
		<div className={classNames.zippy}>
			<div className={classNames['zippy-header']}>
				<div className="w-100 text-capitalize">{title}</div>

				<Conditional isVisible={onEdit !== undefined}>
					<button className={classNames['zippy-header-edit']} onClick={onEdit}>
						<i className="bi bi-pencil-fill"></i>
					</button>
				</Conditional>

				<button
					className={classNames['zippy-header-remove']}
					onClick={onRemove}
				>
					<i className="bi bi-trash3-fill"></i>
				</button>
			</div>

			<div className={classNames['zippy-body']}>{body}</div>
		</div>
	);
};

export default InspectionStandard;
